import formInput from '@/components/forms/input/input.vue';

export default {
  components: {
    formInput,
  },
  props: {
    isInitial: {
      type: Boolean,
      default: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    isApplied: {
      type: Boolean,
      default: false,
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: "This code isn't valid. Try another.",
    },
    appliedCode: {
      type: String,
      default: '',
    },
    appliedAmount: {
      type: [String, Number],
      default: '0.00',
    },
  },
  data() {
    return {
      localCode: '',
    };
  },
  methods: {
    onApply() {
      const trimmed = this.localCode.trim();
      if (trimmed) {
        this.$emit('apply', trimmed);
      }
    },
    onRemove() {
      this.localCode = '';
      this.$emit('remove');
    },
  },
};
